import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { FeedRssCookieService } from '../shared/feed-rss-cookie.service';
import { ConfigurationService } from '../../../shared/configuration.service';

@Component({
    selector: 'dm-feed-rss',
    templateUrl: './feed-rss.component.html',
    styleUrls: ['./feed-rss.component.css'],
    providers: [FeedRssCookieService]
})
export class FeedRssComponent implements OnInit {
    stopShowing = false;
    rssUrl: string;

    constructor(private route: ActivatedRoute,
        private feedRssCookieService: FeedRssCookieService,
        private configurationService: ConfigurationService) {

    }

    ngOnInit() {
        this.route.params.subscribe((params: Params) => {
            const configuration = this.configurationService.configuration;
            const baseUrl = configuration ? configuration.baseSyndicationUrl : '';
            const feedName = params['feed'];
            this.rssUrl = `${baseUrl}/${feedName}/rss`;
        });
    }

    toggle(): void {
        if (this.stopShowing) {
            this.feedRssCookieService.addCookie();
        } else {
            this.feedRssCookieService.removeCookie();
        }
    }
    closeWindow(): void {
        window.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed-rss/feed-rss.component.ts